import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { Pagination } from './pagination.model';

@Injectable()
export class PaginationService {
  constructor(private http: HttpClient) {}
}
